import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Breadcrumb, Card } from 'antd'

import Wrapper from '@common/decorators/Wrapper';
import CheckPermissions from '@common/decorators/CheckPermissions';
import ListEnti from '../../gestioneLR/components/ListEnti';

@Wrapper({ route: 'enti', hasSidebar: true, hasHeader: true, hasFooter: true })
@CheckPermissions(['manageElencoRegionale'])
class GestioneLR extends Component {

  getBreadCrumb() {
    let breads = [
      <Breadcrumb.Item key="dash"><Link to="/dashboard">Home</Link></Breadcrumb.Item>
    ];
    breads.push(<Breadcrumb.Item key="org">Gestione Rappresentante Legale</Breadcrumb.Item>)
    return breads;
  }

  render() {
    return (
      <div>
        <Card
          style={{ marginBottom: '12px', backgroundColor: '#fff' }}
          bordered={false}
        >
          <h3 className="sectionTitle">Gestione Rappresentante Legale</h3>

        </Card>
        <div style={{ padding: '12px' }}>
          <Breadcrumb>
            {this.getBreadCrumb()}
          </Breadcrumb>
        </div>

        <ListEnti ref="listTable" {...this.props} />

      </div>
    );
  }
}


export default GestioneLR;